<template>
  <vx-card title="Create SKU">
    <div class="vx-row mb-6" style="width: 50%">
      <vs-button
        class="ml-4 mt-2"
        color="danger"
        icon-pack="feather"
        icon="icon-arrow-left"
        @click="handleBack()"
      >Back
      </vs-button
      >
    </div>
    <div>
      <div class="vx-row mb-12">
        <div class="vx-col w-1/2">
          <div class="vx-row mb-12">
            <div class="vx-col sm:w-1/5 w-full">
              <span>SKU Code *</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="w-full"
                v-model="skuCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('skuCode')">{{
                  errors.first("skuCode")
                }}</span>
            </div>
          </div>
        </div>

        <div class="vx-col w-1/2">
          <div class="vx-row mb-12">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name *</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="w-full"
                v-model="name"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                  errors.first("name")
                }}</span>
            </div>
          </div>
        </div>

        <div class="vx-col w-1/2">
          <div class="vx-row mb-12">
            <div class="vx-col sm:w-1/5 w-full">
              <span>SKU Type *</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <SkuType
                :value="this.selectedSkuType" @selected="(val) => {this.selectedSkuType = val}"></SkuType>
              <span class="text-danger text-sm" v-show="errors.has('skuType')">{{
                  errors.first("skuType")
                }}</span>
            </div>
          </div>
        </div>

        <div class="vx-col w-1/2">
          <div class="vx-row mb-12">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Unit Of Measure *</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <UnitOfMeasure
                :value="this.selectedUnitOfMeasure"
                @selected="(val) => {this.selectedUnitOfMeasure = val}"></UnitOfMeasure>
              <span class="text-danger text-sm" v-show="errors.has('unitOfMeasure')">{{
                  errors.first("name")
                }}</span>
            </div>
          </div>
        </div>

        <div class="vx-col w-1/2">
          <div class="vx-row mb-12">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Tax *</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <Tax
                :value="this.selectedTax" @selected="(val) => {this.selectedTax = val}">
              </Tax>
              <span class="text-danger text-sm" v-show="errors.has('tax')">{{
                  errors.first("tax")
                }}</span>
            </div>
          </div>
        </div>

        <div class="vx-col w-1/2">
          <div class="vx-row mb-12">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Tax Type</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <TaxType
                :value="this.selectedTaxType" @selected="(val) => {this.selectedTaxType = val}">
              </TaxType>
              <span class="text-danger text-sm" v-show="errors.has('taxType')">{{
                  errors.first("taxType")
                }}</span>
            </div>
          </div>
        </div>

        <div class="vx-col w-1/2">
          <div class="vx-row mb-12">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Sub Tax</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <SubTax
                :taxID="this.selectedTax ? this.selectedTax.id : null"
                :taxTypeID="this.selectedTaxType ? this.selectedTaxType.id : null"
                :value="this.selectedSubTax" @selected="(val) => {this.selectedSubTax = val}"></SubTax>
              <span class="text-danger text-sm" v-show="errors.has('subTax')">{{
                  errors.first("subTax")
                }}</span>
            </div>
          </div>
        </div>

        <div class="vx-col w-1/2">
          <div class="vx-row mb-12">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Add Info</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <AddInfo
                :taxTypeID="this.selectedTaxType ? this.selectedTaxType.id : null"
                :value="this.selectedAddInfo" @selected="(val) => {this.selectedAddInfo = val}"
                v-validate="'required'"></AddInfo>
              <span class="text-danger text-sm" v-show="errors.has('addInfo')">{{
                  errors.first("addInfo")
                }}</span>
            </div>
          </div>
        </div>

        <div class="vx-col w-1/2">
          <div class="vx-row mb-12">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Facility</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <Facility
                :taxTypeID="this.selectedTaxType ? this.selectedTaxType.id : null"
                :value="this.selectedFacility" @selected="(val) => {this.selectedFacility = val}"
                v-validate="'required'"></Facility>
              <span class="text-danger text-sm" v-show="errors.has('facility')">{{
                  errors.first("facility")
                }}</span>
            </div>
          </div>
        </div>

        <div class="vx-col w-1/2">
          <div class="vx-row mb-12">
            <div class="vx-col sm:w-1/5 w-full">
              <span>HS Code</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="w-full"
                v-model="hsCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('hsCode')">{{
                  errors.first("hsCode")
                }}</span>
            </div>
          </div>
        </div>

        <div class="vx-col w-1/2">
          <div class="vx-row mb-12">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Combo</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-switch v-model="isCombo">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
              <span class="text-danger text-sm" v-show="errors.has('isCombo')">{{
                  errors.first("isCombo")
                }}</span>
            </div>
          </div>
        </div>

        <div class="vx-col w-1/2">
          <div class="vx-row mb-12">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Status</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-switch v-model="status">
                <span slot="on">Active</span>
                <span slot="off">Inactive</span>
              </vs-switch>
              <span class="text-danger text-sm" v-show="errors.has('status')">{{
                  errors.first("status")
                }}</span>
            </div>
          </div>
        </div>

        <ImageUpload
          v-model="image"
        >
        </ImageUpload>
      </div>
      <div class="vx-col sm:w-5/5 w-full mb-2">
        <div class="vx-row mb-2">
          <div class="vx-col w-4/12">
            <vs-button
              class="mb-2"
              color="primary"
              icon-pack="feather"
              type="relief"
              icon="icon-check"
              @click="SubmitForm()"
            >
              Save
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>

import SkuType from "../components/SkuType.vue";
import UnitOfMeasure from "../components/UnitOfMeasure.vue";
import Tax from "../components/Tax.vue";
import TaxType from "../components/TaxType.vue";
import SubTax from "../components/SubTax.vue";
import AddInfo from "../components/AddInfo.vue";
import Facility from "../components/Facility.vue";
import ImageUpload from "../components/Image.vue"

export default {
  components: {
    SkuType,
    UnitOfMeasure,
    TaxType,
    Tax,
    SubTax,
    AddInfo,
    Facility,
    ImageUpload,
  },
  data() {
    return {
      skuCode: null,
      name: null,
      selectedSkuType: null,
      selectedUnitOfMeasure: null,
      selectedTax: null,
      selectedTaxType: null,
      selectedSubTax: null,
      selectedAddInfo: null,
      selectedFacility: null,
      hsCode: null,
      isCombo: false,
      status: false,
      image: [],
    }
  },
  methods: {
    handleBack() {
      this.$router.push({
        name: "sku"
      });
    },
    SubmitForm() {
      this.errors.clear();
      let hasError = false;
      if (!this.skuCode) {
        this.errors.add({field: "skuCode", msg: "SKU Code is required"});
        hasError = true;
      }

      if (!this.name) {
        this.errors.add({field: "name", msg: "Name is required"});
        hasError = true;
      }

      if (!this.selectedSkuType) {
        this.errors.add({field: "skuType", msg: "SKU Type is required"});
        hasError = true;
      }

      if (!this.selectedUnitOfMeasure) {
        this.errors.add({field: "unitOfMeasure", msg: "Unit Of Measure is required"});
        hasError = true;
      }

      if (!this.selectedTax) {
        this.errors.add({field: "tax", msg: "Tax is required"});
        hasError = true;
      }

      if (hasError) return;

      const formData = new FormData();
      formData.append("sku_code", this.skuCode);
      formData.append("name", this.name);
      formData.append("sku_type_id", this.selectedSkuType.id);
      formData.append("unit_of_measure_id", this.selectedUnitOfMeasure.id);
      formData.append("tax_id", this.selectedTax.id);
      formData.append("tax_type_id", this.selectedTaxType.id);
      formData.append("sub_tax_id", this.selectedSubTax.id);
      formData.append("add_info_id", this.selectedAddInfo.id);
      formData.append("facility_id", this.selectedFacility.id);
      formData.append("hs_code", this.hsCode);
      formData.append("is_combo", this.isCombo);
      formData.append("status", this.status);
      for (let index = 0; index < this.image.length; index++) {
        formData.append("images[]", this.image[index].File);
      }

      this.$vs.loading({});
      this.$http.post('/api/sfa/v1/master/create-sku', formData, {
        headers: {'Content-Type': 'multipart/form-data'}
      })
        .then((resp) => {
          if (resp.code === 200) {
            this.$vs.notify({
              title: "Success",
              text: "SKU has been saved",
              color: "success",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
            this.handleBack();
          } else {
            this.$vs.notify({
              title: "Error",
              text: resp.message,
              color: "danger",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
          }
          this.$vs.loading.close();
        });
    }
  },
  beforeDestroy() {
    if (this.imagePreview) {
      URL.revokeObjectURL(this.imagePreview);
    }
  },
}
</script>
